/* HeyBear · Pick your bears: pack builder (mixed / single, sizes, subscribe & save), 3D pouch lineup,
   photo gallery, quantity, add to cart (Shopify AJAX cart), sticky mobile CTA.
   Products + prices come from HB.data() (snippets/hb-flavour-data.liquid, set in the Header section). */
HB.section('shop', function (root) {
  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var shopSec = $('[data-hb-shop]'); if (!shopSec) return;
  var D = HB.data(), FLIST = D.flavours || [], BUNDLE = D.bundleFlavours || [], MIXP = D.mix || { variants: [], photos: [] };
  var CARTONS = D.cartonCollection === 'heybear-48g-12-bag-cartons' ? (D.cartons || []) : [];
  var separateProducts = root.getAttribute('data-separate-products') === 'true';
  var viewOnly = root.getAttribute('data-view-only') === 'true';
  var singleProductUrl = root.getAttribute('data-single-product-url') || '';
  var multiBuyEnabled = root.getAttribute('data-multi-buy-enabled') !== 'false';
  var multiBuyMinimum = +root.getAttribute('data-multi-buy-min') || 2;
  var multiBuyPrice = multiBuyEnabled ? (+root.getAttribute('data-multi-buy-price') || 0) : 0;
  if (!FLIST.length) { root.hidden = true; return; }
  var singleModeLink = $('#modeSingleLink');
  if (singleModeLink && FLIST[0] && FLIST[0].url) singleModeLink.href = FLIST[0].url;
  var off = [], triggers = [];
  var on = function (el, ev, fn, o) { if (!el) return; el.addEventListener(ev, fn, o); off.push(function () { el.removeEventListener(ev, fn, o); }); };
  HB.reveal(root);

  var FL = {}, PK = {};
  BUNDLE.forEach(function (f) { FL[f.key] = { name: f.name, pc: f.pc, bc: f.bc, f: f }; PK[f.key] = f.pack; });
  FLIST.forEach(function (f) {
    var visual = FL[f.key] || {};
    FL[f.key] = { name: f.name || visual.name, pc: f.pc || f.itab || visual.pc, bc: f.bc || f.ac || visual.bc, f: Object.assign({}, visual.f || {}, f) };
    PK[f.key] = f.pack || PK[f.key];
  });
  var MIX = (BUNDLE.length ? BUNDLE : FLIST.filter(function (f) { return f.mix; })).map(function (f) { return f.key; });
  var ORDER = FLIST.filter(function (f) { return !f.mix; }).concat(FLIST.filter(function (f) { return f.mix; })).map(function (f) { return f.key; });
  var VISUAL_ORDER = ORDER.concat(MIX.filter(function (key) { return ORDER.indexOf(key) < 0; }));
  var CUB = HB.variantMatch(MIXP, /cub/i), BIG = HB.variantMatch(MIXP, /big/i);
  var V = { cub: CUB, bigbear: BIG };
  var BAGS = { cub: 4, bigbear: 12 };
  function available(v) { return !!(v && v.id && v.available === true && v.price != null); }
  var catalogueRequests = HB.catalogueRequests = HB.catalogueRequests || {};
  function productJsonUrl(product) {
    if (!product || !product.url) return '';
    try {
      var parsed = new URL(product && product.url, location.href);
      parsed.pathname = parsed.pathname.replace(/\/$/, '') + '.js';
      parsed.search = '';
      parsed.hash = '';
      return parsed.href;
    } catch (_) { return ''; }
  }
  function requestProduct(product, refresh) {
    var url = productJsonUrl(product); if (!url) return Promise.resolve(null);
    if (refresh) delete catalogueRequests[url];
    if (!catalogueRequests[url]) {
      catalogueRequests[url] = fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
        if (response.status === 404) return { unavailable: true };
        if (!response.ok) return null;
        return response.json();
      }).catch(function () { return null; });
    }
    return catalogueRequests[url];
  }
  function mergeLiveProduct(product, live) {
    if (!product || !live) return;
    var existing = product.variants || [];
    if (live.unavailable) {
      existing.forEach(function (variant) { variant.available = false; });
      product.available = false;
      return;
    }
    if (!live.variants) return;
    product.variants = live.variants.map(function (variant, index) {
      var prior = existing.filter(function (item) {
        return String(item.id) === String(variant.id) || (item.sku && variant.sku && item.sku === variant.sku);
      })[0] || {};
      return Object.assign({}, prior, {
        id: variant.id,
        title: variant.title,
        sku: variant.sku || prior.sku,
        price: variant.price,
        compare: variant.compare_at_price,
        available: variant.available === true,
        order: prior.order || index + 1,
        plans: prior.plans || []
      });
    });
    product.handle = live.handle || product.handle;
    product.available = product.variants.some(available);
    product.demo = false;
  }
  function mergeLiveCarton(product, live) {
    if (!product || !live) return;
    if (live.unavailable || !live.variants || !live.variants.length) {
      if (product.variant) product.variant.available = false;
      return;
    }
    var prior = product.variant || {};
    var variant = live.variants.filter(function (item) {
      return String(item.id) === String(prior.id) || (prior.sku && item.sku && item.sku === prior.sku);
    })[0] || live.variants[0];
    product.variant = Object.assign({}, prior, {
      id: variant.id,
      title: variant.title,
      sku: variant.sku || prior.sku,
      price: variant.price,
      compare: variant.compare_at_price,
      available: variant.available === true
    });
  }
  var cfg = HB.config();
  var firstMixPack = available(CUB) ? 'cub' : (available(BIG) ? 'bigbear' : 'cub');
  var firstCarton = CARTONS.filter(function (p) { return available(p.variant); })[0] || CARTONS[0];
  var hasMixProduct = !!MIXP.url;
  var S = { buy: 'sub', plan: 0, size: 'big', mode: hasMixProduct ? 'mix' : 'single', pack: firstMixPack, flav: ORDER[0], solo: 3, qty: 1, carton: firstCarton && firstCarton.key, cartonQty: 1 };
  var fmt = HB.fmt, money = HB.money;
  var fan = $('#shopFan');
  if (!hasMixProduct) {
    var mixModeInput = $('#modeMix'), singleModeInput = $('#modeSingle');
    if (mixModeInput && mixModeInput.closest('.mode')) mixModeInput.closest('.mode').hidden = true;
    if (singleModeInput) singleModeInput.checked = true;
    $$('[data-goto="cub"],[data-goto="bigbear"]').forEach(function (control) { control.hidden = true; });
  }

  /* 3D pouch */
  var packEl = $('#shopPack'), pack = HB.mountPack(packEl);
  if (pack) {
    var io = new IntersectionObserver(function (es) { pack.setIdle(es[0].isIntersecting); }); io.observe(packEl);
    off.push(function () { io.disconnect(); });
    pack.setRotation(-8, { immediate: true });
  } else { var st0 = $('#shopStage'); st0 && st0.classList.add('fallback'); }
  var shopSpin = function (v) { if (pack) pack.setRotation(-8 + v); };
  if (HB.gsapReady()) triggers.push(ScrollTrigger.create({ trigger: shopSec, start: 'top bottom', end: 'bottom top', scrub: true, onUpdate: function (s) { shopSpin((s.progress - .5) * 60); } }));

  /* build CSS pouches (fallback when WebGL is unavailable) */
  fan.innerHTML = '';
  VISUAL_ORDER.forEach(function (k) {
    var f = FL[k], w = document.createElement('div'); w.className = 'pouch-wrap'; w.dataset.f = k;
    w.innerHTML = '<div class="pouch" style="--pc:' + f.pc + ';--bc:' + f.bc + '"><div class="side l"></div><div class="side r"></div>' +
      '<div class="face back"><div class="crimp"></div><div class="inner"><div class="pw"><i>Hey</i>Bear</div></div></div>' +
      '<div class="face front"><div class="crimp"></div><span class="grams">102g</span><div class="inner"><div class="pw"><i>Hey</i>Bear</div>' +
      '<div class="window"><svg viewBox="0 0 100 124"><use href="#bear"/></svg></div><div class="pkind">protein gummies</div><div class="pflav">' + f.name + '</div>' +
      '<div class="ptags"><span>17g protein</span><span>Fibre</span></div></div><div class="sheen"></div></div></div>';
    fan.appendChild(w);
  });
  /* flavour radios */
  var grid = $('#flavGrid'); grid.innerHTML = '';
  ORDER.forEach(function (k, i) {
    var l = document.createElement('label'); l.className = 'flav' + (!FL[k].f.mix ? ' wide' : ''); l.style.setProperty('--d', FL[k].pc);
    l.innerHTML = '<input type="radio" name="flav" id="flav-' + k + '" value="' + k + '" ' + (i === 0 ? 'checked' : '') + '><img class="flav-pack" src="' + PK[k] + '" alt=""><span class="flav-n">' + FL[k].name.replace(/^Sour /, '<span class="fl-sour">Sour </span>') + '</span>';
    grid.appendChild(l);
  });
  var cartonGrid = $('#cartonGrid');
  if (cartonGrid) cartonGrid.innerHTML = CARTONS.map(function (p, i) {
    return '<label class="flav" style="--d:' + p.pc + '"><input type="radio" name="carton" value="' + p.key + '" ' + (p.key === S.carton || (!S.carton && i === 0) ? 'checked' : '') + '><img class="flav-pack" src="' + (p.pack || '') + '" alt=""><span class="flav-n">' + p.name + '</span></label>';
  }).join('');
  /* fact tiles under the gallery */
  var facts = $('#facts');
  (function () {
    var left = $('.shop-left'), g2 = $('.shop-grid'), mq = matchMedia('(max-width: 900px)');
    var place = function () { if (mq.matches) { if (facts.parentElement !== g2) g2.appendChild(facts); } else if (facts.parentElement !== left) left.appendChild(facts); };
    place(); mq.addEventListener ? mq.addEventListener('change', place) : mq.addListener(place);
  })();

  /* ---- prices ---- */
  function plansOf(v) { return (v && v.plans) || []; }
  function buildFreq() {
    var sel = $('#subFreq'), v = V[S.pack], ps = plansOf(v); if (!sel) return;
    var cur = sel.value;
    sel.innerHTML = ps.map(function (p, i) { return '<option value="' + i + '">' + p.name + '</option>'; }).join('');
    var di = ps.findIndex(function (p) { return p.default; });
    sel.value = cur !== '' && ps[+cur] ? cur : String(di >= 0 ? di : 0);
    S.plan = +sel.value || 0;
  }
  function plan() { var ps = plansOf(V[S.pack]); return ps[S.plan] || ps[0] || null; }
  function single(k) { return HB.primaryVariant(FL[k].f); }
  function current() {
    if (S.mode === 'mix') {
      var v = V[S.pack], sub = S.buy === 'sub' && plan(), price = sub ? plan().price : (v && v.price != null ? v.price : null);
      return { price: price, variant: v, plan: sub ? plan() : null, short: (S.pack === 'bigbear' ? 'Big Bear · 12 mixed' : 'Cub · 4 mixed') + (sub ? ' · subscribe' : '') };
    }
    var sv = single(S.flav), base = sv && sv.price != null ? sv.price : null;
    var price = base != null && S.qty >= multiBuyMinimum && multiBuyPrice ? multiBuyPrice : base;
    return { price: price, basePrice: base, variant: sv, plan: null, short: '3-Pack · ' + FL[S.flav].name };
  }
  function currentCarton() { return CARTONS.filter(function (p) { return p.key === S.carton; })[0] || null; }
  function updateCarton() {
    var p = currentCarton(), v = p && p.variant, ready = !viewOnly && available(v);
    var total = v && v.price != null ? v.price * S.cartonQty : null;
    if ($('#cartonName')) $('#cartonName').textContent = p ? p.name : '12 × 48g carton';
    if ($('#cartonPrice')) $('#cartonPrice').textContent = v && v.price != null ? money(v.price) : '—';
    if ($('#cartonQty')) $('#cartonQty').textContent = S.cartonQty;
    if ($('#cartonMinus')) $('#cartonMinus').disabled = S.cartonQty <= 1;
    if ($('#cartonTotal')) $('#cartonTotal').textContent = total != null ? money(total) : '—';
    if ($('#cartonAdd')) $('#cartonAdd').disabled = !ready;
    if ($('#cartonBuy')) $('#cartonBuy').hidden = !ready;
    if ($('#cartonFallback')) $('#cartonFallback').hidden = ready;
  }
  var lineupKey = '';
  function layout() {
    if (window.__resetShopView) window.__resetShopView();
    var tp = $('#thPack'); if (tp) tp.style.setProperty('--tp', S.mode === 'single' && S.size === 'big' ? FL[S.flav].pc : HB.mixBg);
    var wraps = [].slice.call(fan.children);
    var sel = (S.size === 'small' || S.mode === 'mix') ? MIX : [S.flav], key = sel.join();
    if (pack && lineupKey !== key) { lineupKey = key; pack.setLineup(sel.map(function (f) { return FL[f].f.k3 || HB.K3[f]; })); }
    var show = (S.size === 'small' || S.mode === 'mix') ? MIX : [S.flav];
    var n = show.length, spread = S.size === 'small' ? 50 : 54;
    wraps.forEach(function (w) {
      var i = show.indexOf(w.dataset.f);
      w.querySelector('.grams').textContent = S.size === 'small' ? '48g' : '102g';
      w.querySelector('.ptags').innerHTML = S.size === 'small' ? '<span>Protein</span><span>Prebiotic fibre</span>' : '<span>17g protein</span><span>Fibre</span>';
      if (i < 0) { w.style.setProperty('--o', 0); w.style.setProperty('--s', .7); w.style.setProperty('--x', '0%'); w.style.setProperty('--z', '-80px'); w.style.setProperty('--r', '0deg'); return; }
      var c = i - (n - 1) / 2, big = S.mode === 'mix' && S.pack === 'bigbear' && S.size === 'big';
      w.style.setProperty('--o', 1);
      w.style.setProperty('--x', (n === 1 ? 0 : c * spread) + '%');
      w.style.setProperty('--y', (Math.abs(c) * 7 + (n === 1 ? -2 : 4)) + '%');
      w.style.setProperty('--z', (n === 1 ? 40 : (10 + i * 18)) + 'px');
      w.style.setProperty('--r', (n === 1 ? -4 : c * 9) + 'deg');
      w.style.setProperty('--s', (n === 1 ? 1.35 : (S.size === 'small' ? .8 : (big ? .95 : .88))));
    });
    var cb = $('#countBubble');
    if (S.size === 'small') { $('#countNum').textContent = '48g'; $('#countSub').textContent = 'snack bags'; }
    else if (S.mode === 'mix') { $('#countNum').textContent = S.pack === 'bigbear' ? '×12' : '×4'; $('#countSub').textContent = 'mixed bags'; }
    else { $('#countNum').textContent = '×' + S.solo; $('#countSub').textContent = 'bags'; }
    cb.classList.add('pop'); setTimeout(function () { cb.classList.remove('pop'); }, 260);
    facts.innerHTML = S.size === 'small' ? facts.getAttribute('data-small') : facts.getAttribute('data-big');
  }
  function update() {
    $('#mixOpts').hidden = S.mode !== 'mix'; $('#singleOpts').hidden = S.mode !== 'single';
    $('#flavName').textContent = FL[S.flav].name; $('#soloDesc').textContent = '3 × 102g ' + FL[S.flav].name;
    var selectedCanSubscribe = S.mode === 'mix' && plansOf(V[S.pack]).length > 0;
    if (selectedCanSubscribe) buildFreq();
    var subInput = $('input[name=buy][value=sub]'), onceInput = $('input[name=buy][value=once]');
    if (subInput) subInput.checked = selectedCanSubscribe && S.buy === 'sub';
    if (onceInput) onceInput.checked = !selectedCanSubscribe || S.buy === 'once';
    var v3 = single(S.flav);
    var selectedSolo = $('input[name=solo][value="' + S.solo + '"]'); if (selectedSolo) selectedSolo.checked = true;
    var selectedMix = $('input[name=size][value="' + S.pack + '"]'); if (selectedMix) selectedMix.checked = true;
    var c = current(), sold = viewOnly || !available(c.variant); $('#qtyVal').textContent = S.qty; $('#qtyMinus').disabled = S.qty <= 1;
    $('#btnPrice').textContent = c.price != null ? money(c.price * S.qty) : '—';
    $('#mctaPrice').textContent = c.price != null ? money(c.price) : '—'; $('#mctaLabel').textContent = c.short;
    /* mixed pack cards */
    var sub = S.buy === 'sub';
    ['cub', 'bigbear'].forEach(function (k) {
      var v = V[k], ps = plansOf(v), pl = ps[S.plan] || ps[0], base = v && v.price != null ? v.price : null, pr = sub && pl ? pl.price : base;
      var pp = $('[data-pp="' + k + '"]'), pb = $('[data-pb="' + k + '"]'), was = $('[data-was="' + k + '"]');
      if (pp) pp.textContent = pr != null ? money(pr) : '—';
      if (pb) pb.textContent = pr != null ? money(pr / BAGS[k]) + ' / bag' : '—';
      if (was) was.textContent = pr != null && sub && pr < base ? money(base) : '';
      var sizeInput = $('input[name=size][value="' + k + '"]'), stock = $('[data-stock="' + k + '"]');
      if (sizeInput) sizeInput.disabled = !available(v); if (stock) stock.hidden = available(v);
    });
    var tag = $('#subTag'), pv = V[S.pack], ppl = plan();
    if (tag && pv && ppl && ppl.price < pv.price) tag.textContent = 'Save ' + Math.round((1 - ppl.price / pv.price) * 100) + '%';
    /* single flavour cards */
    [[3, v3]].forEach(function (x) {
      var pp = $('[data-spp="' + x[0] + '"]'), pb = $('[data-spb="' + x[0] + '"]'), soloInput = $('input[name=solo][value="' + x[0] + '"]'), soloStock = $('[data-solo-stock="' + x[0] + '"]');
      if (x[1] && x[1].price != null) {
        if (pp) pp.textContent = money(x[1].price);
        if (pb) pb.textContent = money(x[1].price / x[0]) + ' / bag';
      } else {
        if (pp) pp.textContent = 'Unavailable online';
        if (pb) pb.textContent = '';
      }
      if (soloInput) soloInput.disabled = !available(x[1]); if (soloStock) soloStock.hidden = available(x[1]);
    });
    var multi = $('#multiBuy');
    if (multi) {
      multi.hidden = !multiBuyEnabled || S.mode !== 'single' || !v3 || v3.price == null;
      multi.classList.toggle('active', !multi.hidden && S.qty >= multiBuyMinimum);
    }
    /* free shipping bar */
    var freeAt = cfg.freeAt, tot = HB.cartTotal() + (c.price || 0) * S.qty, pct = Math.min(100, tot / freeAt * 100);
    $('#shipFill').style.width = pct + '%';
    $('#shipText').innerHTML = (S.mode === 'mix' && S.pack === 'bigbear') || tot >= freeAt
      ? (cfg.t.shipDone || '<b>Nice!</b> Free shipping + a free gift unlocked')
      : String(cfg.t.shipLeft || "You're <b>[amount]</b> away from free shipping + a free gift").replace('[amount]', money(freeAt - tot));
    $('#ship').hidden = sold; $('#shopBuyRow').hidden = sold; $('#mixSoldOut').hidden = !sold;
    var buyType = $('.buy-type'), buyTypeHeading = $('#buyTypeHeading');
    if (buyType) buyType.hidden = !selectedCanSubscribe || sold; if (buyTypeHeading) buyTypeHeading.hidden = !selectedCanSubscribe || sold;
    var waitlistTags = $('#shopWaitlistTags');
    if (waitlistTags) waitlistTags.value = 'product-waitlist,' + (S.mode === 'mix' ? (MIXP.handle || 'mixed-pack') : (FL[S.flav].f.handle || S.flav));
    $('#mcta').hidden = sold;
    updateCarton();
    layout();
  }
  function setSize(sz) {
    S.size = sz; $$('.size-tabs button').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.size === sz); });
    $('#pdpBig').hidden = sz !== 'big'; $('#pdpSmall').hidden = sz !== 'small'; update();
  }
  $$('.size-tabs button').forEach(function (b) { on(b, 'click', function () { setSize(b.dataset.size); }); });
  $$('input[name=mode]').forEach(function (i) { on(i, 'change', function () { S.mode = i.value; update(); }); });
  $$('input[name=size]').forEach(function (i) { on(i, 'change', function () { S.pack = i.value; update(); }); });
  $$('input[name=solo]').forEach(function (i) { on(i, 'change', function () { S.solo = +i.value; update(); }); });
  $$('input[name=buy]').forEach(function (i) { on(i, 'change', function () { S.buy = i.value; update(); }); });
  on($('#subFreq'), 'change', function (e) { S.plan = +e.target.value || 0; update(); });
  on(grid, 'change', function (e) { if (e.target.name === 'flav') { S.flav = e.target.value; update(); } });
  on(cartonGrid, 'change', function (e) { if (e.target.name === 'carton') { S.carton = e.target.value; S.cartonQty = 1; updateCarton(); } });
  $$('[data-goto]').forEach(function (b) {
    on(b, 'click', function () {
      if (b.dataset.goto === 'small') setSize('small');
      else if (hasMixProduct) { $('#modeMix').checked = true; $('#sizeCub').checked = true; S.mode = 'mix'; S.pack = 'cub'; setSize('big'); }
      shopSec.scrollIntoView({ behavior: HB.reduce ? 'auto' : 'smooth' });
    });
  });
  on($('#qtyMinus'), 'click', function () { S.qty = Math.max(1, S.qty - 1); update(); });
  on($('#qtyPlus'), 'click', function () { S.qty = Math.min(20, S.qty + 1); update(); });
  on($('#cartonMinus'), 'click', function () { S.cartonQty = Math.max(1, S.cartonQty - 1); updateCarton(); });
  on($('#cartonPlus'), 'click', function () { S.cartonQty = Math.min(20, S.cartonQty + 1); updateCarton(); });
  on($('#cartonAdd'), 'click', function () {
    var p = currentCarton(), v = p && p.variant, btn = $('#cartonAdd');
    if (viewOnly || !available(v)) return;
    btn.disabled = true;
    var cartonOpenDelay = HB.flyToCart(btn, p.bc || '#D8443B');
    setTimeout(HB.cart.open, cartonOpenDelay);
    HB.cart.add([{ id: v.id, quantity: S.cartonQty }]).then(function () {
      S.cartonQty = 1; updateCarton();
    }).catch(function () {}).then(function () { btn.disabled = false; });
  });

  /* add to cart */
  var addBtn = $('#addBtn');
  on(addBtn, 'click', function () {
    var c = current();
    if (viewOnly || !available(c.variant)) { update(); return; }
    var item = { id: c.variant.id, quantity: S.qty };
    if (c.plan && c.plan.id) item.selling_plan = c.plan.id;
    addBtn.disabled = true;
    var col = S.mode === 'mix' ? FL[MIX[((HB.cart.state && HB.cart.state.item_count) || 0) % MIX.length]].bc : FL[S.flav].bc;
    var cartOpenDelay = HB.flyToCart(addBtn, col);
    setTimeout(HB.cart.open, cartOpenDelay);
    HB.cart.add([item]).then(function () {
      S.qty = 1; update();
    }).catch(function (error) {
      var product = S.mode === 'mix' ? MIXP : FL[S.flav].f;
      requestProduct(product, true).then(function (live) {
        mergeLiveProduct(product, live);
        CUB = HB.variantMatch(MIXP, /cub/i); BIG = HB.variantMatch(MIXP, /big/i); V = { cub: CUB, bigbear: BIG };
        update();
      });
      HB.toast(error && error.message ? error.message : 'This pack is no longer available online.');
    }).then(function () { addBtn.disabled = false; });
  });
  on(document, 'hb:cart:updated', function () { update(); });

  /* small bags notify (Shopify customer form) */
  var nf = $('#notify'), nm = $('#notifyMsg');
  if (nf) {
    nf.noValidate = true;
    on(nf, 'submit', function (e) { var v = ($('#notifyEmail').value || '').trim(); if (!HB.emailOk(v)) { e.preventDefault(); nm.textContent = nm.getAttribute('data-bad'); } });
  }
  var wf = $('#shopWaitlist');
  if (wf) on(wf, 'submit', function () {
    var button = wf.querySelector('button[type="submit"]');
    if (!button) return;
    button.disabled = true; button.textContent = button.getAttribute('data-loading-label') || 'Joining…'; wf.setAttribute('aria-busy', 'true');
  });

  /* gallery: slide 1 = 3D pouch, then product photos */
  (function () {
    var stage = $('#shopStage'), row = $('#thumbs'); if (!stage || !row) return;
    var list = [], cur = 0, key = '';
    function pick() {
      if (S.size === 'big' && S.mode === 'single') return (FL[S.flav].f.photos || []).map(function (src) { return { src: src, f: S.flav }; });
      var out = ((MIXP && MIXP.photos) || []).map(function (src) { return { src: src, f: 'mix' }; });
      var by = MIX.map(function (k) { return (FL[k].f.photos || []).map(function (src) { return { src: src, f: k }; }); });
      for (var i = 0; out.length < 14; i++) { var added = false; by.forEach(function (a) { if (a[i]) { out.push(a[i]); added = true; } }); if (!added) break; }
      return out;
    }
    var NAME = function (f) { return f === 'mix' ? 'Mixed packs' : (FL[f] ? FL[f].name : ''); };
    function show(i) {
      cur = (i + list.length + 1) % (list.length + 1);
      [].slice.call(row.children).forEach(function (t, k) { t.setAttribute('aria-selected', k === cur); });
      var photo = cur > 0, sv = $('#svPhoto');
      sv.hidden = !photo; stage.classList.toggle('alt', photo);
      if (photo) { var p = list[cur - 1], im = $('#svPhotoImg'); im.src = p.src; im.alt = 'HeyBear ' + NAME(p.f) + ' product photo'; sv.style.animation = 'none'; void sv.offsetWidth; sv.style.animation = ''; }
      $('#galCount').textContent = (cur + 1) + ' / ' + (list.length + 1);
      /* Keep the active thumbnail visible without moving the document vertically.
         Element.scrollIntoView() also scrolls ancestor pages, which pulled a fresh
         homepage visit down to the Shop section during the initial show(0). */
      var t = row.children[cur];
      if (t) {
        var thumbLeft = t.offsetLeft - Math.max(0, (row.clientWidth - t.offsetWidth) / 2);
        row.scrollTo({ left: Math.max(0, thumbLeft), behavior: HB.reduce ? 'auto' : 'smooth' });
      }
    }
    function build() {
      list = pick();
      row.innerHTML = '<button type="button" class="thumb" role="tab" aria-label="3D pouch"><span class="th-pack" id="thPack"></span><span class="th-3d">3D</span></button>' +
        list.map(function (p, i) { return '<button type="button" class="thumb photo" role="tab" aria-label="Photo ' + (i + 1) + '"><img src="' + p.src + '" alt="" loading="lazy"></button>'; }).join('');
      [].slice.call(row.children).forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      show(0);
    }
    on($('#galPrev'), 'click', function () { show(cur - 1); });
    on($('#galNext'), 'click', function () { show(cur + 1); });
    on(stage, 'keydown', function (e) { if (e.key === 'ArrowLeft' && cur > 0) show(cur - 1); if (e.key === 'ArrowRight' && cur > 0) show(cur + 1); });
    var sx = null; on($('#svPhoto'), 'pointerdown', function (e) { sx = e.clientX; }); on($('#svPhoto'), 'pointerup', function (e) { if (sx != null && Math.abs(e.clientX - sx) > 40) show(cur + (e.clientX < sx ? 1 : -1)); sx = null; });
    window.__resetShopView = function () {
      var k = (S.size === 'big' && S.mode === 'single') ? S.flav : 'mix';
      if (k !== key) { key = k; build(); var tp = $('#thPack'); if (tp) tp.style.setProperty('--tp', k === 'mix' ? HB.mixBg : FL[k].pc); } else show(0);
    };
    window.__resetShopView();
  })();

  /* selections from other sections (mega menu, Imagine CTA, ?hb-go=) */
  function select(d) {
    var go = d && d.go; if (!go) return;
    if (go === 'flav' && separateProducts) {
      var chosen = d.flav && FL[d.flav] && FL[d.flav].f;
      var target = chosen && chosen.url && !chosen.demo ? chosen.url : singleProductUrl;
      if (target) location.href = target;
      return;
    }
    if (go === 'small') { setSize('small'); return; }
    if ((go === 'cub' || go === 'bigbear') && !hasMixProduct) return;
    setSize('big');
    if (go === 'cub' || go === 'bigbear') { var m = $('#modeMix'); m.checked = true; S.mode = 'mix'; var z = $(go === 'cub' ? '#sizeCub' : '#sizeBig'); z.checked = true; S.pack = go; }
    if (go === 'flav' && d.flav && FL[d.flav]) { var ms = $('#modeSingle'); ms.checked = true; S.mode = 'single'; var fr = $('#flav-' + d.flav); if (fr) fr.checked = true; S.flav = d.flav; }
    update();
  }
  on(document, 'hb:shop:select', function (e) { select(e.detail); });
  var q = /[?&]hb-go=([^&#]+)/.exec(location.search); if (q) select({ go: decodeURIComponent(q[1]) });

  /* sticky mobile CTA: shows after the hero, hides over the shop and the footer */
  var mcta = $('#mcta');
  function onScroll() {
    var r = shopSec.getBoundingClientRect(), fz = document.querySelector('.club'), atFoot = fz && fz.getBoundingClientRect().top < innerHeight - 40;
    if (mcta.hidden) { mcta.classList.remove('show'); return; }
    mcta.classList.toggle('show', scrollY > innerHeight * .7 && !(r.top < innerHeight && r.bottom > 0) && !atFoot);
  }
  on(window, 'scroll', onScroll, { passive: true }); onScroll();

  update();
  /* Liquid renders the catalogue immediately; then reconcile every commerce
     surface with Shopify's live product endpoint. This catches inventory and
     publication changes made after the theme data was rendered without
     replacing any metafield-driven artwork or copy. */
  shopSec.setAttribute('aria-busy', 'true');
  Promise.all([MIXP].concat(FLIST).map(function (product) {
    return requestProduct(product).then(function (live) { mergeLiveProduct(product, live); });
  }).concat(CARTONS.map(function (product) {
    return requestProduct(product).then(function (live) { mergeLiveCarton(product, live); });
  }))).then(function () {
    if (!shopSec.isConnected) return;
    CUB = HB.variantMatch(MIXP, /cub/i); BIG = HB.variantMatch(MIXP, /big/i); V = { cub: CUB, bigbear: BIG };
    if (S.mode === 'mix' && !available(V[S.pack])) S.pack = available(CUB) ? 'cub' : (available(BIG) ? 'bigbear' : S.pack);
    var liveCarton = CARTONS.filter(function (product) { return available(product.variant); })[0];
    if (liveCarton && !available((currentCarton() || {}).variant)) S.carton = liveCarton.key;
    update();
    document.dispatchEvent(new CustomEvent('hb:catalog:updated', { detail: D }));
  }).finally(function () {
    if (shopSec.isConnected) shopSec.removeAttribute('aria-busy');
  });
  return function () { off.forEach(function (f) { f(); }); triggers.forEach(function (t) { t.kill && t.kill(); }); };
});
